import { isMobile, isTablet } from "react-device-detect";

var mult = isMobile || isTablet ? 2 : 1;

export const reel_column_1 = {
  name: "reel_column_1",
  components: [
    {
      name: "reel_1_bg",
      type: "Sprite",
      position: { x: 55, y: 90 },
      img: "major_2_bg",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
    {
      name: "reel_1",
      type: "Sprite",
      position: { x: 55, y: 90 },
      img: "Minister00.png",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
    {
      name: "reel_1_border",
      type: "Sprite",
      position: { x: 25, y: 62 },
      img: "Minister_Frame_Action00.png",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
    {
      name: "reel_2_bg",
      type: "Sprite",
      position: { x: 55, y: 260 },
      img: "major_4_bg",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
    {
      name: "reel_2",
      type: "AnimatedSprite",
      position: { x: 55, y: 260 },
      animation: {
        pattern: "Geisha$.png",
        start: 0,
        end: 71,
        speed: 0.5,
        precision: 2,
        loop: true,
        scale: {
          x: 0.7 * mult,
          y: 0.7 * mult,
        },
      },
    },
    {
      name: "reel_2",
      type: "AnimatedSprite",
      position: { x: 25, y: 232 },
      animation: {
        pattern: "Geisha_Frame_Action$.png",
        start: 0,
        end: 71,
        speed: 0.5,
        precision: 2,
        loop: true,
        scale: {
          x: 0.7 * mult,
          y: 0.7 * mult,
        },
      },
    },
    {
      name: "reel_3",
      type: "Sprite",
      position: { x: 35, y: 420 },
      img: "A00.png",
      scale: { x: 0.62 * mult, y: 0.62 * mult },
    },
  ],
};

export const reel_column_2 = {
  name: "reel_column_2",

  components: [
    {
      name: "reel_4_bg",
      type: "Sprite",
      position: { x: 240, y: 90 },
      img: "major_3_bg",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
    {
      name: "reel_4",
      type: "Sprite",
      position: { x: 240, y: 90 },
      img: "Emperess00.png",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
    {
      name: "reel_4_bg",
      type: "Sprite",
      position: { x: 210, y: 62 },
      img: "Emperess_Frame_Action00.png",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
    {
      name: "reel_5_border",
      type: "AnimatedSprite",
      position: { x: 240, y: 250 },
      animation: {
        pattern: "bgshadowslow_000$.png",
        start: 0,
        end: 59,
        speed: 0.5,
        precision: 2,
        loop: true,
        scale: {
          x: 0.7 * mult,
          y: 0.7 * mult,
        },
      },
    },
    {
      name: "reel_6_bg",
      type: "Sprite",
      position: { x: 240, y: 260 },
      img: "major_4_bg",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
    {
      name: "reel_5",
      type: "AnimatedSprite",
      position: { x: 230, y: 260 },
      animation: {
        pattern: "Geisha$.png",
        start: 0,
        end: 71,
        speed: 0.5,
        precision: 2,
        loop: true,
        scale: {
          x: 0.7 * mult,
          y: 0.7 * mult,
        },
      },
    },
    {
      name: "reel_5",
      type: "AnimatedSprite",
      position: { x: 210, y: 232 },
      animation: {
        pattern: "Geisha_Frame_Action$.png",
        start: 0,
        end: 71,
        speed: 0.5,
        precision: 2,
        loop: true,
        scale: {
          x: 0.7 * mult,
          y: 0.7 * mult,
        },
      },
    },
    {
      name: "reel_6",
      type: "Sprite",
      position: { x: 215, y: 420 },
      img: "Q00.png",
      scale: { x: 0.62 * mult, y: 0.62 * mult },
    },
  ],
};

export const reel_column_3 = {
  name: "reel_column_3",

  components: [
    {
      name: "reel_7",
      type: "Sprite",
      position: { x: 400, y: 75 },
      img: "J00.png",
      scale: { x: 0.62 * mult, y: 0.62 * mult },
    },
    {
      name: "reel_6_bg",
      type: "Sprite",
      position: { x: 420, y: 260 },
      img: "major_4_bg",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
    {
      name: "reel_8_border",
      type: "AnimatedSprite",
      position: { x: 420, y: 260 },
      animation: {
        pattern: "bgshadowslow_000$.png",
        start: 0,
        end: 59,
        speed: 0.5,
        precision: 2,
        loop: true,
        scale: {
          x: 0.7 * mult,
          y: 0.7 * mult,
        },
      },
    },
    {
      name: "reel_8",
      type: "AnimatedSprite",
      position: { x: 420, y: 260 },
      animation: {
        pattern: "Geisha$.png",
        start: 0,
        end: 71,
        speed: 0.5,
        precision: 2,
        loop: true,
        scale: {
          x: 0.7 * mult,
          y: 0.7 * mult,
        },
      },
    },
    {
      name: "reel_8",
      type: "AnimatedSprite",
      position: { x: 390, y: 232 },
      animation: {
        pattern: "Geisha_Frame_Action$.png",
        start: 0,
        end: 71,
        speed: 0.5,
        precision: 2,
        loop: true,
        scale: {
          x: 0.7 * mult,
          y: 0.7 * mult,
        },
      },
    },
    {
      name: "reel_9",
      type: "Sprite",
      position: { x: 400, y: 420 },
      img: "Q00.png",
      scale: { x: 0.62 * mult, y: 0.62 * mult },
    },
  ],
};

export const reel_column_4 = {
  name: "reel_column_4",
  components: [
    {
      name: "reel_10",
      type: "Sprite",
      position: { x: 575, y: 70 },
      img: "A00.png",
      scale: { x: 0.62 * mult, y: 0.62 * mult },
    },
    {
      name: "reel_11_icon",
      type: "AnimatedSprite",
      position: { x: 600, y: 250 },
      animation: {
        pattern: "Emperor$.png",
        start: 0,
        end: 73,
        speed: 0.5,
        precision: 2,
        loop: true,
        scale: {
          x: 0.7 * mult,
          y: 0.7 * mult,
        },
      },
    },
    {
      name: "reel_11_text",
      position: { x: 603, y: 362 },
      type: "AnimatedSprite",
      animation: {
        pattern: "Wild$.png",
        start: 0,
        end: 71,
        speed: 0.5,
        loop: true,
        precision: 2,
        scale: {
          x: 1 * mult,
          y: 1 * mult,
        },
      },
    },
    {
      name: "reel_12",
      type: "Sprite",
      position: { x: 580, y: 420 },
      img: "J00.png",
      scale: { x: 0.62 * mult, y: 0.62 * mult },
    },
  ],
};

export const reel_column_5 = {
  name: "reel_column_5",

  components: [
    {
      name: "reel_13_bg",
      type: "Sprite",
      position: { x: 770, y: 90 },
      img: "major_5_bg",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
    {
      name: "reel_13",
      type: "Sprite",
      position: { x: 770, y: 90 },
      img: "Samurai00.png",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
    {
      name: "reel_13",
      type: "Sprite",
      position: { x: 740, y: 62 },
      img: "Samurai_Frame_Action00.png",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
    {
      name: "reel_14",
      type: "Sprite",
      img: "K00.png",
      position: { x: 755, y: 240 },
      scale: { x: 0.62 * mult, y: 0.62 * mult },
    },
    {
      name: "reel_15_bg",
      type: "Sprite",
      position: { x: 770, y: 440 },
      img: "major_2_bg",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },

    {
      name: "reel_15",
      type: "Sprite",
      position: { x: 770, y: 440 },
      img: "Minister00.png",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
    {
      name: "reel_1_border",
      type: "Sprite",
      position: { x: 740, y: 412 },
      img: "Minister_Frame_Action00.png",
      scale: { x: 0.7 * mult, y: 0.7 * mult },
    },
  ],
};
